/**
 * Chart resolutions of `GET v1/hub/paper-trading/ohlcv`, as TradingView tokens:
 * seconds ("1S"…), minutes ("1"…"240") and the day ("D").
 */
export const PAPER_CANDLE_RESOLUTIONS = ["1S", "15S", "30S", "1", "5", "15", "60", "240", "D"] as const;

export type PaperCandleResolution = (typeof PAPER_CANDLE_RESOLUTIONS)[number];

/**
 * Bars per request. 2000 covers ~3 years at 1D, ~33 hours at 1m or ~33 minutes
 * at 1s — enough for any TradingView page, but tight enough to protect the
 * unauthenticated endpoint from callers requesting millions of buckets. Clients
 * narrow the window to this and page instead.
 */
export const PAPER_CANDLE_MAX_BARS_PER_REQUEST = 2_000;

/** One chart candle. No provider name, by design. */
export type PaperCandle = {
  /** Bucket start, epoch ms (UTC-aligned). */
  timeMs: number;
  /** Decimal strings. */
  open: string;
  high: string;
  low: string;
  close: string;
  /**
   * Base-asset volume. Always "0" — the candle is built from the recorded
   * single price, not trades. Kept on the wire for chart-client compatibility.
   */
  volume: string;
};

/**
 * `GET v1/hub/paper-trading/ohlcv?pairSymbol&resolution&fromMs&toMs`.
 *
 * Series is the recorded single price (upstream history backfilled at 1m+,
 * no bar where no price is known).
 */
export type PaperCandlesResponse = {
  bars: PaperCandle[];
};
